<div *ngIf="behaviorSubjectService.isUserLoginBS | async">
    <span class="listHeaders">
      <i style="font-size: 30px; position: relative; top: 6px;" class="icon icon-card2"></i>
        {{'HOME_CARD_OPERATIONS_LABEL' | translate}}
      <div class="homeHeaderActionButtons"> 
        <!-- <a (click)="open()" style="margin:0px 10px 0px 0px;"> <i class="plus radius" style="--l:15px;--t:3px;--s:3px;--c1:rgb(80 171 57);--c2:white;"></i><span [innerHTML]="'HOME_ADD_NEW_CARD_LABEL' | translate"></span></a>  -->
        <a (click)="onBalanceQueryModal()" style="margin:0px 10px 0px 0px;"> <i class="icon icon-card"></i><span [innerHTML]="'HOME_ADD_NEW_CARD_LABEL' | translate"></span></a> 
        <a (click)="onOnlineChargeModal()"> <i class="icon icon-new_online_charge_icon"></i><span [innerHTML]="'HOME_ONLINE_CHARGE_LABEL' | translate"></span></a> 
      </div>
    </span>
  </div>
  <div *ngIf="isLoading" style="
      transform: scale(0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgb(250, 248, 248);
    ">
    <mat-progress-spinner color="primary" mode="indeterminate">
    </mat-progress-spinner>
</div>
<ngu-carousel *ngIf="behaviorSubjectService.isUserLoginBS | async" #carousel [inputs]="carouselTile" [dataSource]="carouselTileItems">
    <div  class="nguTile" *nguCarouselDef="let item; let itemIndex = index">
      <div *ngIf="!isLoading" class="homeCardSliderItem">
        <div *ngIf="item.typeDescription === 'Card'">
          <app-favorite-card [item]="item" [index]="itemIndex"></app-favorite-card>
        </div>
        <div *ngIf="item.typeDescription === 'QR'">
          <app-qr-card [item]="item" [index]="itemIndex"></app-qr-card>
        </div>
        <div *ngIf="item.typeDescription === 'NFC'">
          <app-nfc [item]="item" [index]="itemIndex"></app-nfc>
        </div>
      </div>
      <!-- <div class="tile">
        <h1>{{ j }}</h1>
      </div> -->
    </div>

    <ul class="myPoint" *ngIf="carouselTileItems.length > 0" NguCarouselPoint>
      <li *ngFor="let j of carousel.pointNumbers; let i = index" [class.active]="j == carousel.activePoint"
        (click)="carousel.moveTo(j)"></li>
      <button NguCarouselPrev class="leftRs" [style.opacity]="carousel.isFirst ? 0.5 : 1"></button>
      <button NguCarouselNext class="rightRs" [style.opacity]="carousel.isLast ? 0.5 : 1"></button>
    </ul>
</ngu-carousel>